/**
 * SKIO Customization Script
 * Wraps "One-time purchase" text in a span for styling
 */

(function() {
  'use strict';

  let hasProcessed = false;
  let checkInterval = null;

  const customizeSkio = () => {
    if (hasProcessed) return;

    // Find input with skio-one-time attribute
    const input = document.querySelector('input[skio-one-time=""]');
    if (!input) {
      console.log('[SKIO Customization] Waiting for one-time input...');
      return;
    }

    // Find parent label
    const label = input.nextElementSibling;
    if (!label || !label.classList.contains('skio-group-label')) {
      console.log('[SKIO Customization] Label not found');
      return;
    }

    // Find topline div
    const topline = label.querySelector('.skio-group-topline');
    if (!topline) {
      console.log('[SKIO Customization] Topline not found');
      return;
    }

    // Check if already wrapped
    if (topline.querySelector('.skio-one-time-text')) {
      console.log('[SKIO Customization] Already wrapped');
      return;
    }

    // Process text nodes
    const childNodes = Array.from(topline.childNodes);
    let wrapped = false;

    childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        
        // Match "One-time purchase" exactly or at start
        if (text && (text === 'One-time purchase' || text.startsWith('One-time purchase'))) {
          const span = document.createElement('span');
          span.className = 'skio-one-time-text';
          span.textContent = text;

          topline.replaceChild(span, node);
          wrapped = true;
          console.log('[SKIO Customization] Wrapped "One-time purchase"');
        }
      }
    });

    // Duplicate price to subscription group-content
    const subscriptionInput = document.querySelector('input[skio-selling-plan-group]');
    if (subscriptionInput) {
      const subscriptionLabel = subscriptionInput.nextElementSibling;
      if (subscriptionLabel && subscriptionLabel.classList.contains('skio-group-label')) {
        const subscriptionTopline = subscriptionLabel.querySelector('.skio-group-topline');
        const groupContent = subscriptionLabel.querySelector('.skio-group-content');
        
        if (subscriptionTopline && groupContent) {
          const price = subscriptionTopline.querySelector('.skio-price');
          if (price && !groupContent.querySelector('.skio-price')) {
            // Clone and append price to group-content
            const priceClone = price.cloneNode(true);
            priceClone.classList.add('skio-price--mobile');
            groupContent.appendChild(priceClone);
            console.log('[SKIO Customization] Cloned price to subscription group-content');
          }
        }
      }
    }

    if (wrapped) {
      hasProcessed = true;
      // Clear interval when done
      if (checkInterval) {
        clearInterval(checkInterval);
        checkInterval = null;
      }
    }
  };

  // Start checking immediately (for already-loaded content)
  customizeSkio();

  // Set up interval to keep checking
  checkInterval = setInterval(() => {
    customizeSkio();
  }, 300);

  // Also hook into SKIO's init if available
  if (window.SkioPlanPickerAutoInit) {
    const originalInit = window.SkioPlanPickerAutoInit;
    window.SkioPlanPickerAutoInit = function() {
      originalInit.apply(this, arguments);
      setTimeout(customizeSkio, 100);
    };
  }

  // Observe document for any changes
  const observer = new MutationObserver(() => {
    customizeSkio();
  });

  const observeTarget = document.querySelector('fieldset[skio-plan-picker]') || document.body;
  observer.observe(observeTarget, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();

